import React, { useEffect, useState } from "react";

const ClientsSection = ({ gpsBrands = [], language }) => {
  const logos = gpsBrands.map((brand) => ({
    name: brand.name,
    src: brand.logo || brand.src,
  }));
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!gpsBrands.length) return undefined;
    const max = Math.ceil(gpsBrands.length / 3);
    const id = setInterval(() => {
      setActive((prev) => (prev + 1) % max);
    }, 4800);
    return () => clearInterval(id);
  }, [gpsBrands]);

  const slides = [];
  for (let i = 0; i < gpsBrands.length; i += 3) {
    slides.push(gpsBrands.slice(i, i + 3));
  }

  return (
    <section className="clients anim-section home-section" id="clientes">
      <div className="home-container">
        <div className="section-head">
          <h2>{language === "es" ? "Marcas GPS compatibles" : "Compatible GPS brands"}</h2>
          <p>
            {language === "es"
              ? "Integraciones validadas con fabricantes lideres para operar sin fricción."
              : "Validated integrations with leading manufacturers to operate without friction."}
          </p>
        </div>
        <div className="logo-marquee">
          <div className="logo-track">
            {[...logos, ...logos].map((logo, idx) => (
              <img
                key={`${logo.name || logo}-${idx}`}
                src={logo.src || logo}
                alt={(logo.name || "").replace(/\.\w+$/, "")}
                loading="lazy"
              />
            ))}
          </div>
        </div>
        <div className="testimonials-slider">
          <div
            className="testimonial-track"
            style={{ transform: `translateX(-${active * 100}%)` }}
          >
            {slides.map((group, idx) => (
              <div className="testimonial-slide" key={`slide-${idx}`}>
                {group.map((brand) => (
                  <article
                    className="testimonial-card card-animated anim-card"
                    key={brand.name}
                  >
                    <div className="testimonial-rating">
                      {language === "es" ? "Integracion validada" : "Validated integration"}
                    </div>
                    <p className="testimonial-quote">{brand.info}</p>
                    <div className="testimonial-footer">
                      <strong>{brand.name}</strong>
                      <span>{language === "es" ? "GPS" : "GPS"}</span>
                    </div>
                  </article>
                ))}
              </div>
            ))}
          </div>
          <div className="testimonial-dots">
            {slides.map((_, idx) => (
              <button
                key={idx}
                type="button"
                className={idx === active ? "dot active" : "dot"}
                aria-label={`${language === "es" ? "Marca" : "Brand"} ${idx + 1}`}
                onClick={() => setActive(idx)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
